export default class Shop {
    constructor() {
        this.preventScrollHallMap();
    }

    /**
     * Prevent scroll if hall map is open
     */
    preventScrollHallMap() {
        document.addEventListener('hallMapDisplay', (event) => {
            if (event.detail.hallMapIsOpen) {
                document.querySelector('body').style.overflow = 'hidden';
            } else if (event.detail.hallMapIsOpen === false) {
                document.querySelector('body').style.overflow = 'inherit';
            }
        });
    }
}
